import {
	computed,
	defineComponent,
	onBeforeMount,
} from 'vue'
import {
	RouterView,
	useRoute,
	useRouter,
} from 'vue-router'

import SimpleHeader from '@vuejs/components/common/SimpleHeader'
import { useGlobalStore } from '@vuejs/stores/GlobalStore'

const ACCOUNT_SETUP_ROUTE_NAME = 'AccountSetupFlow'
const SIGN_UP_ROUTE_NAME = 'SignUpFlow'

export default defineComponent({
	name: 'UnsecuredApp',

	setup() {
		const globalStore = useGlobalStore()
		const route = useRoute()
		const router = useRouter()

		const currentRoute = computed(() => {
			return route ? route.fullPath : window.location.href
		})

		const currentRouteName = computed(() => {
			return route.name ?? router.resolve(window.location.pathname).name
		})

		const hideHeader = computed(() => {
			return currentRouteName.value === SIGN_UP_ROUTE_NAME
		})

		const hideLogout = computed(() => {
			return currentRouteName.value !== ACCOUNT_SETUP_ROUTE_NAME
		})

		const showActivatedInsightsBrand = computed(() => {
			return currentRouteName.value === ACCOUNT_SETUP_ROUTE_NAME
		})

		onBeforeMount(() => {
			globalStore.currentUser = window.current_user
		})

		return {
			currentRoute,
			globalStore,
			hideHeader,
			hideLogout,
			showActivatedInsightsBrand,
		}
	},

	render() {
		return (
			<div
				class={`${String(this.$route.name)}-page unsecured-app w-screen max-w-full`}
				data-test={`${String(this.$route.name)}-page`}
			>
				{!this.hideHeader &&
					<SimpleHeader
						hideLogout={this.hideLogout}
						showActivatedInsightsBrand={this.showActivatedInsightsBrand}
					/>
				}

				<RouterView />
			</div>
		)
	},
})
